export { default } from './ai-product-recommender';
export type { AiProductRecommenderProps } from './ai-product-recommender';
